import LaunchdeckButton from './LaunchdeckButton';


export default function LaunchdeckCreatePostButton({
	label,
	onClickCreatePost,
	userActionRequired,
	inputValue,
	files,
	postType,
	loomVideo,
	setShowUploadImageOption,
	setFiles,
	userTagProperties,
	tempUxPostId,
	loadingLogic,
	width
}) {

	const payload = {
		userActionRequired,
		inputValue,
		files,
		loomVideo,
		postType,
		userTagProperties,
		tempUxPostId
	}
	
	return (
		<LaunchdeckButton 
			bg='brand.500' 
			color={'white'}
			loadingLogic={loadingLogic && loadingLogic}
			width={width && width}
			onClick={label === "Back" ? () => {
				setShowUploadImageOption(false);
				setFiles([]);
			} : ((inputValue || files?.length > 0 || loomVideo) ? () => {
				onClickCreatePost(payload);
			} : undefined)}
			label='Create' 
		/>
	)

}
